/*
 * @Author: Teemo Ding
 * @Date: 2022-03-24 16:03:06
 * @LastEditTime: 2022-04-10 10:58:35
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/StoreVoucher/Detail/Components/ProductsApplyToRadioAndTable/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { get } from 'lodash';
import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import ProductTable from '../ProductTable';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export enum EProductType {
  Specific = 'SpecificProducts',
  All = 'AllProducts',
  NotSpecific = 'ExcludedSpecificProducts',
}
const Item = Form.Item;

const ProductsApplyToRadioAndTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { radioName, tableName, tableId, disabled } = props;
  return (
    <React.Fragment>
      <ItemWrapper
        title={getI18n('voucher.storeVoucherDetail.discountValueAppliesTo')}>
        <Item
          name={radioName}
          rules={[
            { required: true, message: getI18n('general.pleaseselectavalue') },
          ]}>
          <RadioGroup className={css.radioGroup} disabled={disabled}>
            <RadioItem className={css.radio} value={EProductType.All}>
              {getI18n('voucher.storeVoucherDetail.applytoallproducts')}
            </RadioItem>
            <RadioItem className={css.radio} value={EProductType.Specific}>
              {getI18n('voucher.storeVoucherDetail.applytospecificproducts')}
            </RadioItem>
            <RadioItem value={EProductType.NotSpecific}>
              {getI18n('voucher.storeVoucherDetail.notapplytospecificproducts')}
            </RadioItem>
          </RadioGroup>
        </Item>
      </ItemWrapper>
      <Item
        shouldUpdate={(p, c) => {
          const pV = get(p, radioName);
          const cV = get(c, radioName);
          return pV !== cV;
        }}>
        {({ getFieldValue }) => {
          const v = getFieldValue(radioName);
          const hasTable = [EProductType.Specific, EProductType.NotSpecific];
          if (hasTable.includes(v)) {
            return (
              <div className={css.tableContainer}>
                <Item
                  name={tableName}
                  rules={[
                    {
                      validator: async (x, value) => {
                        if ((value || []).length < 1) {
                          return Promise.reject(
                            new Error(
                              getI18n(
                                'general.advancedFilters.commonRadioMulSelect.selectItem',
                              ),
                            ),
                          );
                        }
                      },
                    },
                  ]}>
                  <ProductTable
                    disabled={disabled}
                    hideAlias
                    hideVisibility
                    tableId={`ProductsApplyToRadioAndTable${tableId}`}
                  />
                </Item>
              </div>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default ProductsApplyToRadioAndTable;
